import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Pagination } from 'react-bootstrap';
import Addtestimonial from "./Modal/Addtestimonial";
import EditTestimonial from "./Modal/EditTestimonial";
import DeleteTestimonial from "./Modal/DeleteTestimonial";
import { useSelector } from 'react-redux';
import { IconCirclePlus, IconEdit, IconTrash } from '@tabler/icons-react';
import axios from 'axios';
import Loader from '../../Loader';

const Admintestimonial = () => {
  const [loader, setLoader] = useState(false);
  const [modalAddTestimonialShow, setModalAddTestimonialShow] = useState(false);
  const [modalEditTestimonialShow, setModalEditTestimonialShow] = useState(false);
  const [modalDeleteTestimonialShow, setModalDeleteTestimonialShow] = useState(false);
  const [testimonialId, setTestimonialId] = useState(null);
  const [pagination, setPagination] = useState({
    pages: [],
    currentPage: 1,
    nextPage: false,
    previousPage: false,
    limit: 10,
  });
  const [testimonial, setTestimonial] = useState([]);
  const token = useSelector((state) => state.token);

  const getTestimonial = (page = 1) => {
    setLoader(true);
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_BASE_URL}/testimonial?limit=${pagination.limit}&page=${page}`,
    }).then(res => {
      setLoader(false);
      setTestimonial(res.data.testimonial);
      setPagination((prevState) => ({
        ...prevState,
        currentPage: res.data.currentPage,
        nextPage: res.data.nextPage,
        pages: res.data.pages,
        previousPage: res.data.previousPage
      }));
    }).catch(err => {
      setLoader(false);
    });
  }

  const handleReview = (rating) => {
    let newRating = parseFloat(rating);
    let start = "";
    do {
      if (newRating < 1) {
        start = `${start}<li>
          <i class="fa-solid fa-star-half"></i>
        </li>` ;
      } else {
        start = `${start}<li>
          <i class="fa-solid fa-star"></i>
        </li>`
      }
      newRating = newRating - 1;
    } while (newRating > 0);
    return start;
  }

  useEffect(() => {
    getTestimonial();
  }, []);

  return (
    <>
      <section className="admin_main full">
        <Container fluid>
          <Row>
            <Col md={12}>
              <Card>
                <Card.Header as="h5">
                  <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                    <div className="head_title">
                      <h3 className="mb-0">Testimonial</h3>
                    </div>
                    <Button className="button yellow" onClick={() => setModalAddTestimonialShow(true)}>
                      <IconCirclePlus size={24} stroke={2} /> Add Timonial
                    </Button>
                  </div>
                </Card.Header>
                <Card.Body>
                  {testimonial?.length > 0 ?
                    <>
                      <div className="table-responsive">
                        <table class="client_table">
                          <thead>
                            <tr class="d-none d-lg-table-row">
                              <th width="12%">Country</th>
                              <th width="50%">Feedback</th>
                              <th width="5%">Review</th>
                              <th width="10%">Name</th>
                              <th width="10%">Designation</th>
                              <th className='text-center' width="8%">User image</th>
                              <th className='text-end' width="5%">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {testimonial.map(t => {
                              return (
                                <tr class="tr">
                                  <td>
                                    <strong class="ht">Country : </strong>
                                    <small>{t.country}</small>
                                  </td>
                                  <td>
                                    <strong class="ht">Feedback : </strong>
                                    <small>{t.feedback}</small>
                                  </td>
                                  <td>
                                    <strong class="ht">Review : </strong>
                                    <small>
                                      <ul class="review" dangerouslySetInnerHTML={{ __html: handleReview(t.review) }}>
                                      </ul>
                                    </small>
                                  </td>
                                  <td>
                                    <strong class="ht">Name : </strong>
                                    <small>{t.userName}</small>
                                  </td>
                                  <td>
                                    <strong class="ht">Designation : </strong>
                                    <small>{t.designation}</small>
                                  </td>
                                  <td>
                                    <strong class="ht">User image : </strong>
                                    <p>
                                      <div className="imgtesti">
                                        <img className='sm-img' src={`${process.env.REACT_APP_IMG_BASE_URL}${t.userImage}`} alt="" />
                                      </div>
                                    </p>
                                  </td>
                                  <td>
                                    <strong class="ht">Action : </strong>
                                    <p className="d-flex justify-content-end gap-2">
                                      <Button className="button blue p-1" variant="primary" onClick={() => {
                                        setTestimonialId(t._id);
                                        return setModalEditTestimonialShow(true)
                                      }}>
                                        <IconEdit size={24} stroke={2} />
                                      </Button>
                                      <Button
                                        className="button red p-1"
                                        variant="primary"
                                        onClick={() => {
                                          setTestimonialId(t._id);
                                          return setModalDeleteTestimonialShow(true);
                                        }}>
                                        <IconTrash size={24} stroke={2} />
                                      </Button>
                                    </p>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div className="d-flex justify-content-center mt-4">
                        {pagination.previousPage || pagination.nextPage ?
                          <Pagination>
                            {pagination.previousPage ?
                              <Pagination.Item
                                onClick={() => { getTestimonial(pagination.currentPage - 1) }}
                                key={pagination.currentPage - 1}>
                                {pagination.currentPage - 1}
                              </Pagination.Item>
                              : null}
                            <Pagination.Item
                              active>
                              {pagination.currentPage}
                            </Pagination.Item>
                            {pagination.nextPage ?
                              <Pagination.Item
                                onClick={() => { getTestimonial(pagination.currentPage + 1) }}
                                key={pagination.currentPage + 1}>
                                {pagination.currentPage + 1}
                              </Pagination.Item>
                              : null}
                          </Pagination>
                          : null}
                      </div>
                    </>
                    : <p>Testimonial not found</p>}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      <Loader show={loader} />
      <Addtestimonial
        show={modalAddTestimonialShow}
        getData={() => { getTestimonial() }}
        onHide={() => setModalAddTestimonialShow(false)}
      />
      <EditTestimonial
        show={modalEditTestimonialShow}
        getData={() => { getTestimonial() }}
        testimonialId={testimonialId}
        onHide={() => setModalEditTestimonialShow(false)}
      />
      <DeleteTestimonial
        show={modalDeleteTestimonialShow}
        getData={() => { getTestimonial() }}
        testimonialId={testimonialId}
        onHide={() => setModalDeleteTestimonialShow(false)}
      />
    </>
  )
}

export default Admintestimonial